var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('img',{staticStyle:{"position":"absolute","padding":"16px"},attrs:{"src":"https://d27504pnkoride.cloudfront.net/uploads/2019/03/logo.png","width":"80px"}}),_c('SupplierDashboard')],1)}
var staticRenderFns = []

export { render, staticRenderFns }